import { render, staticRenderFns } from "./OtherPayment.vue?vue&type=template&id=8ee4883a&"
import script from "./OtherPayment.vue?vue&type=script&lang=js&"
export * from "./OtherPayment.vue?vue&type=script&lang=js&"
import style0 from "./OtherPayment.vue?vue&type=style&index=0&id=8ee4883a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports